import {BehaviorSubject} from "rxjs";
import {useCallback, useState} from "react";
import {useObservable} from "../../../rxsupport";

export type StaffingAddendumType = '' | 'ABA_ADDENDUM_REPORT' | 'ABA_SHORT_ADDENDUM';

export type StaffingAddendumAction = {
    visible: boolean;
    addendumType: StaffingAddendumType;
};

export type StaffingAction = '' | 'Staffing Plan' | 'Change Hours Addendum' | 'ABA Addendum Report';

export type StaffingAddendumFinisher = (newReportGuid: string | null) => (Promise<void> | void);

export type StaffingAddendumReport = {
    type: StaffingAddendumType;
    onFinished: StaffingAddendumFinisher;
}

export function useStaffingAction(showStaffingPlan$: BehaviorSubject<boolean>, showAddendum$: BehaviorSubject<StaffingAddendumAction>) {
    const [staffingAction, setStaffingAction] = useState<StaffingAction>('');
    const onStaffingPlanActionSelected = useCallback((action: StaffingAction) => {
        switch (action) {
            case "Staffing Plan":
                showStaffingPlan$.next(true);
                setStaffingAction('Staffing Plan');
                return true;
            case "ABA Addendum Report":
                showAddendum$.next({visible: true, addendumType: 'ABA_ADDENDUM_REPORT'});
                setStaffingAction('ABA Addendum Report');
                return true;
            case "Change Hours Addendum":
                showAddendum$.next({visible: true, addendumType: 'ABA_SHORT_ADDENDUM'});
                setStaffingAction('Change Hours Addendum');
                return true;
            default:
                showAddendum$.next({visible: false, addendumType: ''});
                setStaffingAction('');
                return false;
        }
    }, [showStaffingPlan$, showAddendum$, setStaffingAction]);

    const addendumStaffingAction = useObservable(showAddendum$, {visible: false, addendumType: ''});

    return {
        staffingAction,
        onStaffingPlanActionSelected,
        addendumStaffingAction
    };
}
